import React, { Fragment } from "react";
import { smallDate as formatDate } from "../../lib/DateFormatting";
import SampleLink from "../SampleLink";
import Link, { EmptyLink } from "../Link";
import { ElipsisTd, CenterTd, EmptyTd } from "./theme/Theme";
import SampleCommentCounts from "../sample_reporting/SampleCommentCounts";

export default function SampleColumns({
  showSample,
  sample,
  clientView,
  handleSelectSample,
  isSampleSelected,
  viewSingleSample,
  simpleSampleView,
  toggleComments,
  toggleRetests
}) {
  var padding = 0;
  if (simpleSampleView) {
    padding = 2;
  } else {
    if (clientView) {
      padding = 7;
    } else {
      padding = 8;
    }
  }
  if (!showSample) return <EmptyTd colSpan={padding} />;
  return (
    <Fragment>
      <CenterTd>
        <input type="checkbox" onChange={handleSelectSample} checked={isSampleSelected} />
      </CenterTd>
      {!simpleSampleView && !clientView && (
        <Fragment>
          <ElipsisTd>{sample.sample.company_name}</ElipsisTd>
        </Fragment>
      )}

      <CenterTd>
        <SampleCommentCounts
          {...sample.sample}
          clientView={clientView}
          handleShowComments={toggleComments}
          handleShowRetests={toggleRetests}
        />
        &nbsp;
        <SampleLink sample={sample.sample} disabled={clientView} />
        &nbsp;&nbsp;&nbsp;&nbsp;
        <Link onClick={viewSingleSample}>
          <i className="fa fa-eye" />
        </Link>
      </CenterTd>
      {!simpleSampleView && (
        <Fragment>
          <ElipsisTd>{sample.sample.product_name}</ElipsisTd>
          <CenterTd>{formatDate(sample.sample.requested_test_date)}</CenterTd>
          <CenterTd>{formatDate(sample.sample.registered_at)}</CenterTd>
          <CenterTd>{formatDate(sample.sample.received_at)}</CenterTd>
          <CenterTd>{formatDate(sample.sample.due_date)}</CenterTd>
        </Fragment>
      )}
    </Fragment>
  );
}
